export const setCadastroInicial = 'fidelidade/setCadastroInicial'
export const atualizaCadastroCliente = 'fidelidade/atualizaCadastroCliente'



// WEBPACK FOOTER //
// ./src/domain/leiloes/store/mutations-types.js